import React from 'react';
import './Modal.css';

export default class Modal extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div className={this.props.showModal ? "modal is-active" : "modal"}>
                <div className="modal-background" onClick={() => this.props.cancel()}/>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">{this.props.modalTitle}</p>
                    <button onClick={() => this.props.cancel()} className="delete" aria-label="close"></button>
                    </header>
                    <section className="modal-card-body">
                        {this.props.children}
                    </section>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/modal/Modal.js